import popup from "./popup.vue"

const Popup = {
  install(Vue) {
    Vue.component("popup", popup)
    Vue.prototype.$popup = {
      image: async (image, skip = true, skipAfter = 0, video) => {
        return this._init({ type: "image", image: image, skip: skip, skipAfter: skipAfter, video: video })
      },
      video: async (video, skip = true, skipAfter = 0, loop = false) => {
        return this._init({ type: "video", video: video, skip: skip, skipAfter: skipAfter, loop })
      },
      videoWithPlayerControl: async (video, loop = false) => {
        return this._init({ type: "video", video: video, skip: false, skipAfter: 0, playerControl: true, loop })
      },
      slideshow: async (images, skipAfter = 0, video) => {
        return this._init({ type: "slideshow", image: images, skip: true, skipAfter: skipAfter, video: video })
      }
    }
  },

  async _init(data) {
    try {
      const promise = await _$.progress.create()

      const $package = {
        type: data.type,
        video: data.video,
        image: data.image,
        skip: data.skip,
        skipAfter: data.skipAfter,
        loop: data.loop || false,
        playerControl: data.playerControl || false,
        resolve: e => {
          promise.resolve(e)
        },
        reject: e => {
          promise.reject(e)
        }
      }

      _$.vue.$emit("popup", $package)

      return promise.done
    } catch (err) {
      return _$.error(err)
    }
  }
}

export default Popup
